import React from 'react';

import { TbChevronRight } from 'react-icons/tb';

import Icon from 'components-new/icon/icon';

import Crumb from './crumb';
import type { CrumbType } from './crumb';

interface BreadcrumbsProps {
  crumbs: CrumbType[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ crumbs }) => {
  return (
    <div className="pb-1 flex items-center">
      {crumbs &&
        crumbs.map((crumb, _index) => (
          <React.Fragment key={crumb.name}>
            <Crumb name={crumb.name} onClick={crumb.onClick} />
            {_index < crumbs.length - 1 && (
              <Icon icon={TbChevronRight} size={14} className="mx-2" />
            )}
          </React.Fragment>
        ))}
    </div>
  );
};

export default Breadcrumbs;
